
import { ConfigApi } from '@/api/ConfigApi';
import { defineStore } from 'pinia'

// TODO: sysDatetimeのデフォルトがnullで良いかは開発中に検討
// （APIから取れない場合、クライアントの日時を使わないといろいろおかしくなりそう）
interface ConfigState {
  sysDatetime: Date | null,
  dakokuRound: number,
}

export const useConfigStore = defineStore('config', {
  state: (): ConfigState => ({
    sysDatetime: null,
    dakokuRound: 1,
  }),
  actions: {
    async init() {
      const api = new ConfigApi();
      this.sysDatetime = await api.getSystemDatetime();
      this.dakokuRound = await api.getDakokuRound();
    },
    /*
    * 業務日時をサーバーから取得しStoreへ保存します
    * クライアント上でこの時間は経過しないので注意
    * @returns
    */
    async getSysDatetime() {
      const api = new ConfigApi();
      this.sysDatetime = await api.getSystemDatetime();
      return this.sysDatetime;
    },
    /**
    * 打刻の丸め時間（分）をサーバーから取得しStoreへ保存します
    * @returns
    */
    async getDakokuRound() {
      const api = new ConfigApi();
      this.dakokuRound = await api.getDakokuRound();
      return this.dakokuRound;
    }
  },
  getters: {
  }
})
